import pinyin from 'pinyin-match'
const commonFn = {
    toast(type, msg) {
        bus.$message({
            message: msg,
            type: type
        })
    },
    notify(type, title, msg) {
        bus.$notify({
            title: title,
            message: msg,
            type: type
        });
    },
    trimTree(tree) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i].children.length == 0) {
                delete tree[i].children
            } else {
                this.trimTree(tree[i].children)
            }
        }
    },
    sortFilter(sort) {
        if (sort.prop) {
            return sort.prop + ' ' + sort.order.replace('descending', 'desc').replace('ascending', 'asc')
        } else {
            return ''
        }
    },
    toNumber(data) {
        console.log(data);
        data = data.replace(/[^0-9.]/g, '')
        return data
    },
    // 多选款模糊查询方法
    paramMatch(param1, param2, val,name) {
        // console.log(param1);
        // console.log(param2);
        // console.log(val);
        // console.log(name);
        let copydiagnosisOptions = Object.assign(param1)
      if (val) {
        param2 = copydiagnosisOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item[name]) {
            if (item[name].toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item[name], val)
          }
        })
      } else {
        param2 = copydiagnosisOptions
        }
        return param2
        
    },
    // 医嘱模糊查询方法
    drugMatch(param1, param2, val,name,name1) {
        // console.log(param1);
        // console.log(param2);
        // console.log(val);
        // console.log(name);
        // console.log(name1);
        let copydiagnosisOptions = Object.assign(param1)
      if (val) {
        param2 = copydiagnosisOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item[name]||item[name1]) {
            if (item[name].toUpperCase().indexOf(val.toUpperCase()) != -1||item[name1].toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item[name], val)
          }
        })
      } else {
        param2 = copydiagnosisOptions
        }
        return param2
        
    },
    // 标准日转化为年月日
    transformTime(date) {
        const d = new Date(date);
        let y = d.getFullYear();
        let m = d.getMonth() + 1;
        let s = d.getDate();
        if (m < 10) m = "0" + m;
        if (s < 10) s = "0" + s;
        const datetime = y + "-" + m + "-" + s;
        return datetime;
    },
    getMonths() {
        var now = new Date(); //当前日期
        var nowMonth = now.getMonth(); //当前月
        var nowYear = now.getFullYear(); //当前年
        //本月的开始时间
        var monthStartDate = _g.transformTime(new Date(nowYear, nowMonth, 1));
        //本月的结束时间
        var monthEndDate = _g.transformTime(new Date(nowYear, nowMonth + 1, 0));
        return [monthStartDate, monthEndDate]
    },
    // 字符串数组转数字数组
    turnNum(nums) {
        return nums.map(Number);
      },
}

export default commonFn